














































import { Vue, Component, Watch } from "vue-property-decorator";
import { FilePayload } from "@/store/template/types";

@Component
export default class BaseDataForm extends Vue {
  // Vuex store with lightweight typed wrapper
  readonly store = this.$store.direct;

  form: { name?: string; description?: string; source?: FilePayload } = {
    name: undefined,
    description: undefined,
    source: undefined
  };

  utils: { buffer: File | null } = {
    buffer: null
  };

  toBase64 = (file: File) =>
    new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        let encoded = (reader.result as string | ArrayBuffer)
          .toString()
          .replace(/^.*,/, "");
        if (encoded.length % 4 > 0) {
          encoded += "=".repeat(4 - (encoded.length % 4));
        }
        resolve(encoded);
      };
      reader.onerror = error => reject(error);
    });

  get source() {
    return this.utils.buffer;
  }

  set source(b: File | null) {
    if (b) {
      this.setSource(b);
    } else {
      this.form.source = undefined;
    }
    this.utils.buffer = b;
  }

  async setSource(file: File) {
    this.form.source = {
      name: file.name,
      size: file.size,
      content: await this.toBase64(file)
    };
  }

  get edit() {
    return !!this.store.state.template.selected.id;
  }

  rules = {
    required: (v: string) => (!!v && v.length > 0) || "Campo requerido",
    requiredFile: (f: any) => !!f || "Campo requerido"
  };

  get valid() {
    return (
      this.form.name &&
      this.form.name.length > 0 &&
      this.form.name.length < 30 &&
      this.form.description &&
      this.form.description.length > 0 &&
      this.form.description.length < 200 &&
      (this.edit || (this.form.source && this.form.source.size < 2e7))
    );
  }

  @Watch("store.state.template.selected.id")
  onSelectedChange(newVal: string, oldVal: string) {
    if (newVal) {
      this.form = {
        name: this.store.state.template.selected.name,
        description: this.store.state.template.selected.description,
        source: this.store.state.template.selected.source
      };
    }
  }
}
